<span *ngIf="data !== null; else plug">{{ data | delimitNumber }}</span>
<ng-template #plug> </ng-template>
